import React from 'react'
import Select from "react-select";
import { selectLanguageStyles } from '../../utils';

const LanguageSelect = ({
    label_text,
    options, state,
    setState,
    isDisabled,
    isMulti,
    placeholder,
    disableClearable,
    disableSearch,
    menuTop
}) => {
    const handleChange = (value) => {
        if (!value) {
            setState("")
        } else {
            setState(value)
        }
    }

    // useEffect(() => {
    //     console.log("Language: ", state);
    // }, [state])

    return (
        <div className=' z-10 '>
            <span className="text-xs font-medium mb-1 block">
                {label_text}
            </span>

            <Select
                placeholder={placeholder}
                isDisabled={isDisabled}
                styles={selectLanguageStyles(state ? true : false)}
                options={options}
                onChange={value => handleChange(value)}
                value={state}
                isMulti={isMulti}
                isClearable={disableClearable ? false : true}
                isSearchable={disableSearch ? false : true}
                menuPlacement={menuTop ? "top" : "auto"}
            />
        </div>
    )
}

export default LanguageSelect